import { gql } from "@apollo/client";
import { TEMPLATE_FIELD_FIELDS } from "./TemplateField";

export const PERMIT_TEMPLATE_FIELDS = gql`
  ${TEMPLATE_FIELD_FIELDS}
  fragment PermitTemplateFields on PermitTemplate {
    fields {
      ...TemplateFieldFields
    }
    features {
      catAndGenny {
        enabled
      }
      gisBoundary {
        enabled
        geofencingStatus {
          value
          options
        }
        geofencingToleranceMeters
      }
      asBuilt {
        enabled
        asBuiltCompletionDeclarations
      }
      gangMembers {
        enabled
        permitMustHaveGangMembersToIssue
        briefingCheckListItems
        briefingDeclaration
      }
      sitePhoto {
        enabled
        requireSitePhotoForSubmission
        requireSitePhotoForRequest
      }
      affectedServices {
        enabled
      }
    }
    configuration {
      preRequestDeclarations
      preSubmissionDeclarations
      optionToSelectThePermitTeamInThePermitRequest
      maxPermitDurationDays
      maxPermitValidInAdvanceDays
    }
  }
`;
